import React, { useContext } from "react";
import { AppContext } from "../../App";
import { document } from "../../rbac-consts";
import Can from "../can/Can";
import AmlBotSubDocumentDetailsContainer from "./client/amlBot/DocumentDetailsContainer";
import SumSubDocumentDetailsContainer from "./client/sumSub/DocumentDetailsContainer";

const DocumentDetailsWrapper = ({ match }) => {

  const { user } = useContext(AppContext);

  return (
    <Can
      role={user.roles}
      perform={document.USER}
      yes={() => {
        if (!match.params.type) {
          return <></>;
        }

        switch (match.params.type) {
          case "sumSub":
            return (
              <SumSubDocumentDetailsContainer match={match} />
            );
          case "amlBot":
            return (
              <AmlBotSubDocumentDetailsContainer match={match} />
            );
        }
      }}
    />
  );
};

export default DocumentDetailsWrapper;